import { Box, Button, Input, TextField, makeStyles } from '@material-ui/core';
import React, { FC, useState } from 'react';
import { ChromePicker } from 'react-color';
import { useDispatch, useSelector } from 'react-redux';
import useComponentVisible from 'src/hooks/useComponentVisible';
import colorRectangle from 'src/images/colorRectangle.png';
import { RootState } from 'src/store';
import {
  editBtnText,
  editBtnFontSize,
  editBtnFontWeight,
  editBtnFontFamily,
  editBtnColor
} from 'src/store/modules/buttons';

import Plus from 'src/components/Icon/Plus';
import Minus from 'src/components/Icon/Minus';

import ChevronUp from 'src/components/Icon/ChevronUp';
import ChevronDown from 'src/components/Icon/ChevronDown';
import FontFamilyPicker from '../FontFamilyPicker';
import EditBtnBgColor from '../EditBtnBgColorRegurcy';

interface editBtnProps {
  type: string;
}

const useStyles = makeStyles(() => ({
  input: {
    height: '4.5rem',
    padding: '0.5rem',
    outline: 'none',
    overflow: 'hidden',

    '&:focus': {
      border: 0,
      outline: 'none'
    },

    border: '1px solid #dddddd'
  },
  inputRoot: {
    padding: 0,
    height: '100%',
    display: 'block'
  },
  inputText: {
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: '1.2rem',
    letterSpacing: '0.015rem'
  }
}));

const EditBtnText: FC<editBtnProps> = ({ type }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  let currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  let btnText = useSelector((state: RootState) => state.buttons.btnText);

  const handleBtnText = e => {
    let newBtnText = JSON.parse(JSON.stringify(btnText));
    newBtnText[type][currentIndex] = e.target.value;
    dispatch(editBtnText(newBtnText));
  };

  return (
    <TextField
      className={classes.input}
      id="standard-multiline-flexible"
      multiline
      InputProps={{
        classes: {
          root: classes.inputRoot,
          input: classes.inputText
        },
        disableUnderline: true
      }}
      value={btnText?.[type]?.[currentIndex]}
      onChange={handleBtnText}
    />
  );
};

export default EditBtnText;
